import React from 'react'

import ExpandablePanel from '../controls/ExpandablePanel'
import FormControl from '@material-ui/core/FormControl'
import TextField from '@material-ui/core/TextField'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import { controlHasError } from '../../lib/errorHandler'
import AnimateHeight from 'react-animate-height'

class AdresZagraniczny extends React.Component {
  constructor(props) {
    super(props)
    this.myRef = React.createRef()
  }

  render() {
    return (
      <ExpandablePanel title="SIEDZIBA I ADRES PRZEDSIĘBIORCY ZAGRANICZNEGO">
        <form autoComplete="off" className="adresZagraniczny" ref={this.myRef}>
          <FormControlLabel
            className="checkboxLabel"
            control={
              <Checkbox
                name="JestAdresZagraniczny"
                color="primary"
                checked={this.props.data.JestAdresZagraniczny}
                onChange={e =>
                  this.props.onSetSectionData(e.target.name, e.target.checked)
                }
              />
            }
            label="Podmiot jest oddziałem (zakładem) przedsiębiorcy zagranicznego"
          />

          <AnimateHeight
            duration={250}
            height={this.props.data.JestAdresZagraniczny ? 'auto' : 0}
            onAnimationEnd={() => this.myRef.current.scrollIntoView()}
          >
            <div className="secondRow">
              <FormControl component="fieldset">
                <TextField
                  error={controlHasError(this.props.errors, 'ZUlica')}
                  name="ZUlica"
                  label="Ulica"
                  title={this.props.data.ZUlica}
                  defaultValue={this.props.data.ZUlica}
                  onBlur={e =>
                    this.props.onSetSectionData(e.target.name, e.target.value)
                  }
                />
              </FormControl>
              <FormControl component="fieldset">
                <TextField
                  error={controlHasError(this.props.errors, 'ZNrDomu')}
                  name="ZNrDomu"
                  label="Nr domu"
                  title={this.props.data.ZNrDomu}
                  defaultValue={this.props.data.ZNrDomu}
                  onBlur={e =>
                    this.props.onSetSectionData(e.target.name, e.target.value)
                  }
                />
              </FormControl>

              <FormControl component="fieldset">
                <TextField
                  error={controlHasError(this.props.errors, 'ZNrLokalu')}
                  name="ZNrLokalu"
                  label="Nr lokalu"
                  title={this.props.data.ZNrLokalu}
                  defaultValue={this.props.data.ZNrLokalu}
                  onBlur={e =>
                    this.props.onSetSectionData(e.target.name, e.target.value)
                  }
                />
              </FormControl>
            </div>
            <div className="thirdRow">
              <FormControl component="fieldset">
                <TextField
                  error={controlHasError(this.props.errors, 'ZKodPocztowy')}
                  name="ZKodPocztowy"
                  label="Kod pocztowy"
                  title={this.props.data.ZKodPocztowy}
                  defaultValue={this.props.data.ZKodPocztowy}
                  onBlur={e =>
                    this.props.onSetSectionData(e.target.name, e.target.value)
                  }
                />
              </FormControl>
              <FormControl component="fieldset">
                <TextField
                  error={controlHasError(this.props.errors, 'ZMiejscowosc')}
                  name="ZMiejscowosc"
                  label="Miejscowość"
                  title={this.props.data.ZMiejscowosc}
                  defaultValue={this.props.data.ZMiejscowosc}
                  onBlur={e =>
                    this.props.onSetSectionData(e.target.name, e.target.value)
                  }
                />
              </FormControl>
              <FormControl component="fieldset">
                <TextField
                  error={controlHasError(this.props.errors, 'ZKodKraju')}
                  name="ZKodKraju"
                  label="Kod kraju"
                  title={this.props.data.ZKodKraju}
                  defaultValue={this.props.data.ZKodKraju}
                  onBlur={e =>
                    this.props.onSetSectionData(e.target.name, e.target.value)
                  }
                />
              </FormControl>
            </div>
          </AnimateHeight>
        </form>
      </ExpandablePanel>
    )
  }
}

export default AdresZagraniczny
